import React, { useState, useRef } from "react";
import { Grid, Input, MenuItem, Select, InputLabel, Checkbox, TextField, Typography } from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import "../Booking.css";
import Paper from "@mui/material/Paper";

const HealthDetails = ({
    setAsthmaOrBronchitis, asthmaOrBronchitisValue,
    setFitsFaintingBlack, fitsFaintingBlackValue,
    setHeartCondition, heartConditionValue,
    setSevereHeadaches, severeHeadachesValue,
    setDiabetes, diabetesValue,
    setAllergiesToKnownMedicines, allergiesToKnownMedicinesValue,
    setOtherAllergies, otherAllergiesValue,
    setTravelSickness, travelSicknessValue,
    setBedwettingIncontinence, bedwettingIncontinenceValue,
    setAnyMentalHealthProblems, anyMentalHealthProblemsValue,
    setRegularMedication, regularMedicationValue,
    setRegularHospitalTreatment, regularHospitalTreatmentValue,
    setAnyMedicationPring, anyMedicationPringValue,
    setAnyThingElse, anythingElseValue,
    setMoreDetails, moreDetailsValue,
    setAgreeNonPrescription, agreeNonPrescriptionValue,
    setArrangeMedicalTreatment, arrangeMedicalTreatmentValue,
    hideTitle, editVersion,
    roomingComment, setRoomingComment,
    medicalComment, setMedicalComment,
    isFormInvalid, readonly
}) => {

    return (
        <Paper elevation={3} display="flex" className={"step-container"}>
            {!hideTitle ?
                <>
                    <h2>Health details</h2>
                    <Box sx={{ color: 'primary.main_light' }}>
                        <Typography fontSize={17} fontWeight={'bold'} marginBottom={2} marginTop={2}>
                            Does your child have
                        </Typography>
                    </Box>
                </>
                : <></>}

            <Grid container spacing={2} width={800}>
                <Grid item xs={6}>

                    <FormControl error={(isFormInvalid && asthmaOrBronchitisValue == null)}>
                        <FormLabel>Asthma or bronchitis *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={asthmaOrBronchitisValue == 1} onChange={(e) => setAsthmaOrBronchitis(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={asthmaOrBronchitisValue == 0} onChange={(e) => setAsthmaOrBronchitis(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && fitsFaintingBlackValue == null)}>
                        <FormLabel>Fits, fainting or blackouts *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={fitsFaintingBlackValue == 1} onChange={(e) => setFitsFaintingBlack(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={fitsFaintingBlackValue == 0} onChange={(e) => setFitsFaintingBlack(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && heartConditionValue == null)}>
                        <FormLabel>Heart condition *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={heartConditionValue == 1} onChange={(e) => setHeartCondition(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={heartConditionValue == 0} onChange={(e) => setHeartCondition(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && severeHeadachesValue == null)}>
                        <FormLabel>Severe headaches *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={severeHeadachesValue == 1} onChange={(e) => setSevereHeadaches(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={severeHeadachesValue == 0} onChange={(e) => setSevereHeadaches(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && diabetesValue == null)}>
                        <FormLabel>Diabetes *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={diabetesValue == 1} onChange={(e) => setDiabetes(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={diabetesValue == 0} onChange={(e) => setDiabetes(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Grid item xs={6}>
                    <FormControl error={(isFormInvalid && allergiesToKnownMedicinesValue == null)}>
                        <FormLabel>Allergies to known medicines *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={allergiesToKnownMedicinesValue == 1} onChange={(e) => setAllergiesToKnownMedicines(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={allergiesToKnownMedicinesValue == 0} onChange={(e) => setAllergiesToKnownMedicines(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && otherAllergiesValue == null)}>
                        <FormLabel>{editVersion ? 'Other allergies *' : 'Other allergies (materials, food, etc) *'}</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={otherAllergiesValue == 1} onChange={(e) => setOtherAllergies(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={otherAllergiesValue == 0} onChange={(e) => setOtherAllergies(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && travelSicknessValue == null)}>
                        <FormLabel>Travel sickness *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={travelSicknessValue == 1} onChange={(e) => setTravelSickness(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={travelSicknessValue == 0} onChange={(e) => setTravelSickness(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && bedwettingIncontinenceValue == null)}>
                        <FormLabel>Bed-wetting/incontinence *</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={bedwettingIncontinenceValue == 1} onChange={(e) => setBedwettingIncontinence(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={bedwettingIncontinenceValue == 0} onChange={(e) => setBedwettingIncontinence(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && anyMentalHealthProblemsValue == null)}>
                        <FormLabel>{editVersion ? 'Any mental health problems *' : 'Any mental health problems (including eating disorders, hyperactivity) *'}</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={anyMentalHealthProblemsValue == 1} onChange={(e) => setAnyMentalHealthProblems(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={anyMentalHealthProblemsValue == 0} onChange={(e) => setAnyMentalHealthProblems(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                </Grid>
            </Grid>
            {!hideTitle ?
                <Box sx={{ color: 'primary.main_light' }}>
                    <Typography fontSize={17} fontWeight={'bold'} marginBottom={2} marginTop={2}>
                        Additional Questions *
                    </Typography>
                </Box> : <></>}

            <Grid container>
                <Grid item xs={12}>
                    <FormControl error={(isFormInvalid && regularMedicationValue == null)}>
                        <FormLabel>{editVersion ? 'Regular medication *' : 'Is your child on regular medication ? *'}</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={regularMedicationValue == 1} onChange={(e) => setRegularMedication(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={regularMedicationValue == 0} onChange={(e) => setRegularMedication(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && regularHospitalTreatmentValue == null)}>
                        <FormLabel>{editVersion ? 'Require regular hospital treatment *' : 'Does your child require regular hospital treatment? *'}</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={regularHospitalTreatmentValue == 1} onChange={(e) => setRegularHospitalTreatment(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={regularHospitalTreatmentValue == 0} onChange={(e) => setRegularHospitalTreatment(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && anyMedicationPringValue == null)}>
                        <FormLabel>{editVersion ? 'Any Medication bring *' : 'Does your child take any medication which he/she will bring with him/her? *'}</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={anyMedicationPringValue == 1} onChange={(e) => setAnyMedicationPring(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={anyMedicationPringValue == 0} onChange={(e) => setAnyMedicationPring(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && agreeNonPrescriptionValue == null)}>
                        <FormLabel>{editVersion ? 'Authorize non-prescription medication *' : 'In case of minor pain or illness such as headache, mild cold or sore throat, do you agree to your son/daughter being given non-presciption medication such as Paracetamol, cough medicine, throat pastilles, antihistamine or travel sickness tablets? *'}</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={agreeNonPrescriptionValue == 1} onChange={(e) => setAgreeNonPrescription(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={agreeNonPrescriptionValue == 0} onChange={(e) => setAgreeNonPrescription(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <br></br>
                    <FormControl error={(isFormInvalid && arrangeMedicalTreatmentValue == null)}>
                        <FormLabel>{editVersion ? 'Authorize medical treatment arrangement *' : 'In case of an emergency do you give permission for a LINES responsible person to arrange medical treatment. Of course, every effort will be made to contact you, the child’s parents/guardians, as quickly as possible *'}</FormLabel>
                        <RadioGroup row>
                            <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={arrangeMedicalTreatmentValue == 1} onChange={(e) => setArrangeMedicalTreatment(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={arrangeMedicalTreatmentValue == 0} onChange={(e) => setArrangeMedicalTreatment(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>

            <Grid xs={12} sx={{ mb:2 }}>
                <FormLabel>Rooming comment</FormLabel>
                <TextField
                    style={{ width: "100%" }}
                    multiline
                    disabled={readonly}
                    onChange={(e) => setRoomingComment(e.target.value)}
                    value={roomingComment}
                    maxRows={4}
                    variant="filled"
                    inputProps={{ maxLength: 250 }}
                     />
            </Grid>
            <Grid container>
                {!editVersion ?
                    <Grid xs={12} sx={{ mb:2 }}>
                        <FormControl error={(isFormInvalid && anythingElseValue == null)}>
                            <FormLabel>Is there anything else we should know about? *</FormLabel>
                            <RadioGroup row>
                                <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={anythingElseValue == 1} onChange={(e) => setAnyThingElse(e.target.value)} />} label="Yes" />
                                <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={anythingElseValue == 0} onChange={(e) => setAnyThingElse(e.target.value)} />} label="No" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    : <></>
                }
                {(anythingElseValue == 1 || editVersion) &&
                    <Grid xs={12} sx={{ mt: 0 }}>
                        <FormLabel>Medical comment</FormLabel>
                        <TextField
                            style={{ width: "100%" }}
                            multiline
                            disabled={readonly}
                            onChange={(e) => setMoreDetails(e.target.value)}
                            value={moreDetailsValue}
                            maxRows={4}
                            variant="filled" 
                            inputProps={{ maxLength: 250 }}/>
                    </Grid>}
            </Grid>
        </Paper>)
}

export default HealthDetails